<script>
	import { getContext } from "svelte";
	import { tweened } from "svelte/motion";
	import { px, percent } from "../utils";

	import { animationParameters, currentLowestPoint, currentLowestPointMonth } from "../stores";

	const { padding, xGet, yGet, xScale, yScale, data, xRange, yRange } = getContext("LayerCake");

	export let prefix = "";
	export let format = (d) => d;

	$: startPos = [0.5 * ($xRange[1] - $xRange[0]), 0.5 * ($yRange[0] - $yRange[1])];

	$: minData = $currentLowestPoint;
	$: minPos = [$xGet(minData), $yGet(minData)];

	const tMinPos = tweened(startPos, $animationParameters);
	$: tMinPos.set(minPos);
</script>

<div
	class="lowest-point-container"
	class:left={$tMinPos[0] < 3}
	class:right={$tMinPos[0] > 97}
	class:top={$tMinPos[1] < 30}
	style:left={percent($tMinPos[0])}
	style:top={percent($tMinPos[1])}
>
	<div class="label">
		<span class="prefix">{prefix}</span><br />
		<span class="data">{format(minData)}</span>
	</div>
	<div class="arrow" />
</div>

<style lang="scss">
	.lowest-point-container {
		position: absolute;
		transform: translate(-50%, -100%);
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		row-gap: 8px;
	}

	.left {
		.label {
			text-align: left;
			transform: translate(50%, 0%);
		}

		.arrow {
			transform: translate(50%, 0%);
		}
	}

	.top {
		transform: translate(-50%, 0);
		flex-direction: column-reverse;

		.arrow {
			transform: scale(1, -1);
		}
	}

	.right {
		.label {
			text-align: right;
			transform: translate(-50%, 0%);
		}

		.arrow {
			transform: translate(-50%, 0%);
		}
	}

	.label {
		color: #2a2a2a;
		font-weight: 400;
		font-size: 11.5px;
		line-height: 11px;
		letter-spacing: 0.04em;
		// margin-bottom: 8px;
	}

	.data {
		font-weight: 600;
	}

	.arrow {
		width: 0;
		height: 0;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;

		border-top: 8px solid #2a2a2a;
	}
</style>
